class TipoParecerSolMovIBPEnum {

    constructor(descricao, value) {
        this.descricao = descricao;
        this.value = value;
    }

    static fromValue(value) {
        return Object.values(TipoParecerSolMovIBPEnum).find(status => status.value === value);
    }

    static fromDescricao(descricao) {
        return Object.values(TipoParecerSolMovIBPEnum).find(status => status.descricao === descricao);
    }
}


TipoParecerSolMovIBPEnum.APROVADO = new TipoParecerSolMovIBPEnum("Aprovado", 10);
TipoParecerSolMovIBPEnum.REPROVADO = new TipoParecerSolMovIBPEnum("Reprovado", 11);
TipoParecerSolMovIBPEnum.PARCIAL = new TipoParecerSolMovIBPEnum("Parcial", 12);


export default TipoParecerSolMovIBPEnum;